import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { useEffect, useState } from 'react';
import pushOptimizelyEvent from 'pathfinder/utils/pushOptimizelyEvent';
import { DesktopNonStickyButton } from './DesktopNonStickyButton';
import { DesktopStickyButton } from './DesktopStickyButton';
import { MobileNonStickyButton } from './MobileNonStickyButton';
import { MobileStickyButton } from './MobileStickyButton';
import { TooltipContextProvider } from './Context';
export default function AddToMyFandomsRoot({ track, variant, desktopStickyRoot, desktopNonStickyRoot, mobileStickyRoot, mobileNonStickyRoot, initialActiveState, doAddToMyFandoms, doRemoveFromMyFandoms, }) {
    const [isActive, setIsActive] = useState(initialActiveState !== null && initialActiveState !== void 0 ? initialActiveState : false);
    useEffect(() => {
        track.impression({ label: 'add-to-my-fandoms-button' });
        pushOptimizelyEvent('pathfinder_add_to_my_fandoms_button_impression');
    }, []);
    const handleClick = () => {
        if (isActive) {
            track.click({ label: 'remove-from-fandoms' });
            pushOptimizelyEvent('pathfinder_add_to_my_fandoms_remove_click');
            doRemoveFromMyFandoms();
            setIsActive(false);
            return false;
        }
        else {
            track.click({ label: 'add-to-fandoms' });
            pushOptimizelyEvent('pathfinder_add_to_my_fandoms_click');
            doAddToMyFandoms();
            setIsActive(true);
            return true;
        }
    };
    const isVideoOnPage = typeof (window === null || window === void 0 ? void 0 : window.canPlayVideo) === 'function' && window.canPlayVideo();
    const isMobileWithVideo = !!(desktopStickyRoot || mobileNonStickyRoot) && isVideoOnPage;
    return (_jsxs(TooltipContextProvider, Object.assign({ isMobileWithVideo: isMobileWithVideo }, { children: [desktopNonStickyRoot && (_jsx(DesktopNonStickyButton, { isAlreadyAdded: isActive, handleClick: handleClick, root: desktopNonStickyRoot, variant: variant }, void 0)), desktopStickyRoot && (_jsx(DesktopStickyButton, { isAlreadyAdded: isActive, handleClick: handleClick, root: desktopStickyRoot, variant: variant }, void 0)), mobileNonStickyRoot && (_jsx(MobileNonStickyButton, { isAlreadyAdded: isActive, handleClick: handleClick, root: mobileNonStickyRoot, variant: variant }, void 0)), mobileStickyRoot && (_jsx(MobileStickyButton, { isAlreadyAdded: isActive, handleClick: handleClick, root: mobileStickyRoot, variant: variant }, void 0))] }), void 0));
}
